function r(n, p = 0) {
  const o = [];
  for (const t of n)
    o.push([t.X, p, t.Y]);
  return o.push(o[0]), o;
}
export {
  r as pathToPoly
};
//# sourceMappingURL=index6.js.map
